import * as idEndpoints from './id';
import { me } from './me';

export const users = {
  id: {
    ...idEndpoints,
  },
  me,
};
